"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const houston_styles_1 = tslib_1.__importStar(require("@eduzz/houston-styles"));
const getColorFallback_1 = tslib_1.__importDefault(require("../utils/getColorFallback"));
const SIZE_BASE = 65;
const CIRCLE_SIZE_BASE = 30;
const Spinner = ({ className, size = SIZE_BASE }) => {
    const round = (size / SIZE_BASE) * CIRCLE_SIZE_BASE;
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ className: className, width: `${size}px`, height: `${size}px`, viewBox: `0 0 ${size + 1} ${size + 1}` }, { children: (0, jsx_runtime_1.jsx)("circle", { fill: 'none', strokeLinecap: 'round', cx: round + round * 0.1, cy: round + round * 0.1, r: round }) })));
};
const rotationAnimation = (0, houston_styles_1.keyframes) `
  0% { transform: rotate(0deg); }
  100% { transform: rotate(270deg); }
`;
const circleAnimation = (size) => (0, houston_styles_1.keyframes) `
  0% { stroke-dashoffset: ${(size / SIZE_BASE) * 187}; }
  50% { stroke-dashoffset: ${(size / SIZE_BASE) * 46.75}; transform: rotate(135deg); }
  100% { stroke-dashoffset: ${(size / SIZE_BASE) * 187}; transform: rotate(450deg); }
`;
exports.default = (0, houston_styles_1.default)(Spinner, { label: 'houston-loader' }) `
  ${({ theme, color, size = SIZE_BASE }) => (0, houston_styles_1.css) `
    animation: ${rotationAnimation} 1.4s linear infinite;
    color: ${color === 'inherit' ? 'inherit' : (0, getColorFallback_1.default)(theme, color).pure};

    & > circle {
      stroke: currentColor;
      stroke-width: ${(size / SIZE_BASE) * 6};
      stroke-dasharray: ${(size / SIZE_BASE) * 187};
      stroke-dashoffset: 0;
      transform-origin: center;
      animation: ${circleAnimation(size)} 1.4s ease-in-out infinite;
    }
  `}
`;
